/**
 * @generated SignedSource<<f04ffaa4d1a83d681ce14e7d9d3952b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_userPermissionsRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"agentVerificationDropdownItem_AtlaskitRovoAgentComponents_userPermissionsRef">;
  readonly " $fragmentType": "viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_userPermissionsRef";
};
export type viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_userPermissionsRef$key = {
  readonly " $data"?: viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_userPermissionsRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_userPermissionsRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_userPermissionsRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_userPermissionsRef"
    }
  ],
  "type": "AtlassianStudioUserProductPermissions"
};

(node as any).hash = "824d3211daa85c08f19577449540e6d6";

export default node;
